import { createSelector } from 'reselect'

export const getData = state => state.reportTransports.getIn(['all', 'objects'])
export const createGetDataSelector = () => createSelector([getData], data => data)
